import {
    LIST_LEAGUES_LOADING,
    LIST_LEAGUES_SUCCESS,
    LIST_LEAGUES_ERROR,
  } from "../../../constant/actionTypes";
  
  const listLeagueReducer = (state = {}, action) => {
    switch (action.type) {
      case LIST_LEAGUES_LOADING: {
        let obj = {
          loading: true,
        };
        return obj;
      }
      case LIST_LEAGUES_SUCCESS: {
        let obj = {
          loading: false,
          data: action.response,
        };
        return obj;
      }
      case LIST_LEAGUES_ERROR: {
        let obj = {
          loading: false,
          status: action.response,
        };
        return obj;
      }
      default:
        return state;
    }
  };
  
  export default listLeagueReducer;
  